import { UNCATEGORIZED_POIS_KEYS } from '@/config'

export function isSpecialPois (subcategories = []) {
  return subcategories.find(x => UNCATEGORIZED_POIS_KEYS.includes(x.toString()))
}
